import { render, staticRenderFns } from "./chakanbaogao.vue?vue&type=template&id=159c015a&scoped=true&"
import script from "./chakanbaogao.vue?vue&type=script&lang=js&"
export * from "./chakanbaogao.vue?vue&type=script&lang=js&"
import style0 from "./chakanbaogao.vue?vue&type=style&index=0&id=159c015a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c015a",
  null
  
)

export default component.exports